import { render, staticRenderFns } from "./index.vue?vue&type=template&id=568f524e"
import script from "./isdDistributionInvoice.js?vue&type=script&lang=js&external"
export * from "./isdDistributionInvoice.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports